import { getFromLocalStorage, putToLocalStorage } from "./localStorageService";
import { UpdateAction } from "@/models/socketIo/updateAction";

export type StorageMode = "local" | "extended";

export const getLocalActionHistory = (matchId: string) =>
  getFromLocalStorage("actionHistory")?.[matchId];

export const addLocalActionHistory = (
  matchId: string,
  updateAction: UpdateAction,
): UpdateAction[] => {
  const actionHistoryData = getFromLocalStorage("actionHistory") || {};
  const existingActionHistory =
    actionHistoryData?.[matchId]?.actionHistory || [];
  const updatedActionHistory = [
    ...existingActionHistory.filter(
      (action) => action.orderRank !== updateAction.orderRank,
    ),
    updateAction,
  ];
  putToLocalStorage("actionHistory", {
    ...actionHistoryData,
    [matchId]: { matchId, actionHistory: updatedActionHistory },
  });
  return updatedActionHistory;
};

export const updateLocalActionHistory = (
  matchId: string,
  actionHistory: UpdateAction[],
): UpdateAction[] => {
  const actionHistoryData = getFromLocalStorage("actionHistory") || {};
  putToLocalStorage("actionHistory", {
    ...actionHistoryData,
    [matchId]: { matchId, actionHistory },
  });
  return actionHistory;
};

export const removeLocalActionHistory = (matchId: string) => {
  const actionHistoryData = getFromLocalStorage("actionHistory") || {};
  delete actionHistoryData[matchId];
  putToLocalStorage("actionHistory", actionHistoryData);
};
